import { Injectable, signal } from '@angular/core';
import { FeedbackService, FeedbackType, IFeedbackShowOptions } from '@resident-nx/shared';

@Injectable({
  providedIn: 'root',
})
export class FeedbackWebService extends FeedbackService {
  toasts = signal([]);

  hide(): Promise<void> {
    return Promise.resolve(undefined);
  }

  show(_options: IFeedbackShowOptions): Promise<void> {
    const toastColor = _options.type === FeedbackType.Success ? 'bg-success' : 'bg-danger';

    this.toasts.update(toasts => [
      ...toasts,
      {
        textOrTpl: _options.message,
        classname: `${toastColor} text-light`,
        delay: _options.duration,
      },
    ]);

    return Promise.resolve(undefined);
  }

  remove(toast: []): void {
    this.toasts.update(toasts => toasts.filter(t => t !== toast));
  }
}
